(function( $ ) {
		'use strict';

		ready( findOnBookstore );

		/**
		 * Detect if doc is ready and fire func inside
		 *
		 * @param fn
		 */
		function ready( fn ) {
			if ( document.attachEvent
					? document.readyState === 'complete'
					: document.readyState !== 'loading' ) {
				fn();
			} else {
				document.addEventListener( 'DOMContentLoaded', fn );
			}
		}

		function findOnBookstore() {
			//don't run if we're not on the bookstore
			if ( document.body.classList ) {
				if ( !document.body.classList.contains( 'post-type-archive-book' ) ) {
					return;
				}
			}

			let findSupported = false;

			if ( window.find ) {
				findSupported = true;
			}

			if ( !findSupported ) {
				document.getElementById( 'bookstore-find-on-page' ).style.display = 'none';
				return;
			}

			let findBtn = document.getElementById('btn-find-catalog-text'),
			findInput = document.getElementById('find-on-page'),
			catContent = document.getElementById('catalog-content'),
			catContentLinks = document.querySelectorAll('.catalog-content-section a'),
			resultsSpan = document.getElementById('bookstore-find-on-page-results'),
			currentResult = 0,
			totalResults = 0,
			i;

			if ( 'undefined' !== typeof ISDA_Main.libraryAccessStatus ) {
				for ( i = 0; i < catContentLinks.length; ++i ) {
					catContentLinks[ i ].addEventListener( 'click', function( e ) {
						e.preventDefault();
						let bookLink = this.getAttribute( 'href' );

						if ( bookLink.indexOf('isda.org/book/') > -1 ) {
							if ( ISDA_Main.libraryAccessStatus === 'PLUS' ) {
								//if online lib member, send user to plus version of book
								window.location.href = bookLink + 'library';
							} else {
								//send user to regular book link
								window.location.href = bookLink;
							}
						} else {
							//if this isn't a book, continue with link normally
							window.location.href = bookLink;
						}
					} );
				}
			}

			if ('undefined' === typeof findBtn || 'undefined' === typeof findInput) {
				return;
			}
		
			function performSearch(e) {
				e.preventDefault();
		
				let searchTerm = findInput.value.trim();
				if (searchTerm === '') {
					resultsSpan.textContent = '';
					return;
				}
		
				let textContent = catContent.textContent || catContent.innerText;
				let regex = new RegExp(searchTerm, 'gi');
				let matches = textContent.match(regex);
				totalResults = matches ? matches.length : 0;
		
				if (totalResults > 0) {
					currentResult = (currentResult % totalResults) + 1;
					resultsSpan.textContent = `${currentResult} of ${totalResults} result${totalResults > 1 ? 's' : ''}`;
				} else {
					resultsSpan.textContent = 'No results';
					currentResult = 0;
				}
		
				window.find(searchTerm, false, false, catContent, false, false, false);
			}
		
			findBtn.addEventListener('click', performSearch);
			findInput.addEventListener('keypress', function(e) {
				if (e.key === 'Enter') {
					performSearch(e);
				}
			});
		}
	}
)( jQuery );